// @owner ClientPlatform

import {css, styled} from 'styled-components';

export const cardStyles = css`
  width: 332px;
  margin: auto;
  padding: 48px;

  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.09);
  border: 1px solid var(--color-border-alpha);
  border-radius: 20px;

  display: flex;
  flex-direction: column;
  gap: 32px;
  text-align: center;
`;

export const Card = styled.div`
  ${cardStyles}
`;
